import { memo } from 'react';
import { Page } from '@betty/navigation';
import AccountMFA from '../components/AccountMFA/AccountMFA';
import React from 'react';
import { Box } from '@betty/moonlight';

function AccountMFAModal() {
  return (
    <Page>
      <Box width="100%">
        <AccountMFA />
      </Box>
    </Page>
  );
}

export default memo(AccountMFAModal);
